<script>
    import { onMount } from "svelte";

    import {
        CustomTooltip,
        TableComponentContainer,
    } from "../../../../Common/index.svelte";

    export let row = {};

    const truncateMaxWidth = 150;

    let isTruncated = false;

    onMount(() => {
        setTimeout(() => {
            checkIfTruncated();
        }, 1000);
    });

    const checkIfTruncated = () => {
        const hiddenContainer = document.createElement("div");
        hiddenContainer.style.position = "absolute";
        hiddenContainer.style.visibility = "hidden";
        hiddenContainer.style.whiteSpace = "nowrap";
        hiddenContainer.style.pointerEvents = "none";
        document.body.appendChild(hiddenContainer);

        hiddenContainer.style.fontSize = "14px";
        hiddenContainer.style.fontWeight = "400";

        hiddenContainer.innerHTML = `${_getHospital(row.hospital)}`;

        isTruncated = hiddenContainer.scrollWidth + 10 > truncateMaxWidth;

        document.body.removeChild(hiddenContainer);
    };

    // HELPER FUNCTIONS
    const _getHospital = (hospital) => {
        if (hospital) {
            const { name, address, suburb, state, postcode, providerNumber } =
                hospital;

            return `${name} - ${address}, ${suburb}, ${state}, ${postcode} (${providerNumber})`;
        } else return "No hospital";
    };
</script>

<TableComponentContainer>
    <div
        class="flex flex-1 items-center justify-start w-[{truncateMaxWidth}px]"
    >
        {#if isTruncated}
            <CustomTooltip
                contentClass="bg-[#fff] border-none"
                contentStyle="box-shadow: 4px 4px 13.7px 1px rgba(0, 0, 0, 0.25);"
                zIndex="10"
                hideTimeOutMs={50}
            >
                <p
                    class="text-left truncate cursor-pointer"
                    style="max-width: {truncateMaxWidth}px;"
                    slot="tooltipTrigger"
                >
                    {_getHospital(row.hospital)}
                </p>

                <p class="text-left cursor-text">
                    {_getHospital(row.hospital)}
                </p>
            </CustomTooltip>
        {:else}
            <p
                class="text-left truncate"
                style="max-width: {truncateMaxWidth}px;"
            >
                {_getHospital(row.hospital)}
            </p>
        {/if}
    </div>
</TableComponentContainer>
